import { Modal } from "antd";
import { TableWarehouses } from "../../../../modules/products/ui/productById/TableWarehouses";

export const ModalProductWarehouses = ({
  openModal,
  setOpenModal,
}: {
  openModal: boolean;
  setOpenModal: (val: boolean) => void;
}) => {

  return (
    <Modal
      footer={null}
      style={{}}
      title={`Asignar un producto a la bodega`}
      open={openModal}
      width={"90%"}
      onCancel={() => setOpenModal(false)}
    >
      <TableWarehouses />
    </Modal>
  );
};
